<template>
    <mhospital style="margin-bottom:10px" ref="main0" title="患者" table_name="user" table_show_header>
        <!-- 弹出编辑模态窗口 -->
        <template #writeForm="{writeForm}">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="姓名" prop="name" :required="true">
                        <el-input v-model="writeForm.name" style="width: 180px;"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="手机号" prop="mobile" :required="true">
                        <el-input v-model="writeForm.mobile" minlength="11" maxlength="11" style="width: 180px;"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="性别" prop="sex" :required="true">
                        <el-radio-group v-model="writeForm.sex">
                            <el-radio-button label="1">男</el-radio-button>
                            <el-radio-button label="2">女</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="身高" prop="height" :required="true">
                        <el-input v-model="writeForm.height" placeholder="单位cm" style="width: 180px;"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="体重" prop="weight" :required="true">
                        <el-input v-model="writeForm.weight" placeholder="单位kg" style="width: 180px;"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="birth" label="出生日期">
                        <el-date-picker value-format="yyyy-MM-dd" clearable v-model="writeForm.birth" type="date"
                                        placeholder="请输入yyyy-mm-dd" style="width: 180px;"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="科室" prop="department">
                        <el-input v-model="writeForm.department"  style="width: 180px;"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="admission" label="住院号">
                        <el-input v-model="writeForm.admission"  style="width: 180px;"/>
                    </el-form-item>

                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item prop="bed_number" label="床号">
                        <el-input v-model="writeForm.bed_number"  style="width: 180px;"/>
                    </el-form-item>

                </el-col>
                <el-col :span="12">
                    <el-form-item label="门诊号" prop="outpatient">
                        <el-input v-model="writeForm.outpatient"  style="width: 180px;"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item prop="icase" label="备注">
                    <el-input clearable type="textarea" style="width: 180px;" :rows="4" v-model="writeForm.icase"
                              placeholder=""/>
                </el-form-item>
            </el-row>
        </template>
        <!-- 搜索框 -->
        <template #searchForm="{searchForm}" style="background-color: #1c6ca1">

            <el-form-item label="姓名" prop="name">
                <el-input v-model="searchForm.name" clearable/>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="searchForm.mobile" clearable/>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="searchForm.sex">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button label="0">未填写</el-radio-button>
                    <el-radio-button label="1">男</el-radio-button>
                    <el-radio-button label="2">女</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="birth" label="年龄范围" style="margin-left: 30px;">
                <el-date-picker style="width: 330px" value-format="yyyy-MM-dd" v-model="searchForm.birth"
                                type="daterange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>

            </el-form-item>
            <el-form-item prop="icase" label="备注">
                <el-input v-model="searchForm.icase" clearable/>
            </el-form-item>
            <el-form-item prop="create_time" label="添加时间">
                <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.create_time" type="daterange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
            </el-form-item>
            <el-form-item prop="hospital_id" label="社区医院" v-if="hrole<11">
                <el-select v-model="searchForm.hospital_id" placeholder="请选择" clearable filterable
                           size="small"
                           @change="search_btn('main0')">
                    <el-option value="" label="全部"/>
                    <el-option v-for="item in hospital_opt" :key="item.id" :label="item.name"
                               :value="item.id"/>
                </el-select>
            </el-form-item>
        </template>
        <!-- 列表 -->
        <template #table>
            <!-- <el-table-column label="基本信息"> -->
            <el-table-column label="编号" width="70" prop="ids" align="center"/>
            <el-table-column v-if="hrole=='1'" label="社区医院" width="160" prop="hospital.name" align="center"/>
            <el-table-column label="姓名" width="80" align="center">
                <template slot-scope="scope">
                    <el-link type="primary" @click="goto_report_by_uid(scope.row.id)">{{scope.row.name}}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="手机号" prop="mobile" width="120" align="center"/>
            <el-table-column v-if="hrole<11" label="社区" prop="hospital.name" align="center"/>
            <el-table-column label="性别" prop="sex" align="center" width="60"/>
            <el-table-column label="出生日期" prop="birth" width="120" align="center"/>
            <el-table-column label="身高" prop="height" align="center" width="60"/>
            <el-table-column label="体重" prop="weight" align="center" width="60"/>
            <el-table-column label="备注" prop="icase" align="left"/>
            <el-table-column label="添加时间" prop="create_time" width="180" align="center"/>
            <!-- </el-table-column> -->
            <!-- <el-table-column label="实时状态"> -->
            <el-table-column label="绑定设备" align="center" width="80">
                <template slot-scope="scope">
					<span v-if="scope.row.device&&scope.row.device.id>0">
<!--                        <span>{{scope.row.device.note}}</span>-->
                        <!--                           <span>{{scope.row.device.imei}}</span>-->
                        	<el-tag type="success" size="mini">已绑定</el-tag>
					</span>
                    <span v-else>
						<el-tag type="danger" size="mini">未绑定</el-tag>
					</span>
                </template>
            </el-table-column>
            <el-table-column label="最近一次报告" align="center" width="110">
                <template slot-scope="scope">
                    <template v-if="scope.row.report&&scope.row.report.id>0">
                        <el-tag type="success" v-if="scope.row.report.is_24==1" size="mini">已生成</el-tag>
                        <el-tag type="danger" v-else size="mini">未生成</el-tag>
                    </template>
                    <template v-else>
                        <el-tag type="info" size="mini">未测量</el-tag>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="最近一次测量开始时间" align="center" width="180">
                <template slot-scope="scope">
                    <template v-if="scope.row.report&&scope.row.report.id>0">
                        <el-link type="primary" @click="look_report(scope.row.report.id)">{{scope.row.report.DT}}
                        </el-link>
                    </template>
                    <template v-else>
                        -
                    </template>
                </template>
            </el-table-column>
            <!-- </el-table-column> -->
            <el-table-column label="操作" width="160" align="center">
                <template slot-scope=" scope">
                    <el-link style="margin-right:10px" icon="el-icon-edit" type="primary"
                             @click="edit_btn('main0', scope.row.id)">编辑
                    </el-link>
                    <el-link icon="el-icon-delete" type="primary" @click="del_btn('main0', scope.row.id)">删除</el-link>
                </template>
            </el-table-column>
        </template>
    </mhospital>

</template>
<script>
    import mhospital from "../../components/mhospital.vue";
    import request from "../../plugins/axios";

    export default {
        data() {
            return {
                uid_opt: [],
                hrole: '',
                hospital_opt: [],
            };
        },
        components: {
            mhospital,
        },
        mounted() {
            request({
                url: "/hospital/Read/hospital_opt",
                data: {},
            }).then((ret) => {
                if (ret.code == 1) {
                    this.hospital_opt = ret.data;
                }
            });
            this.hrole = localStorage.getItem('hrole')
        },
        methods: {
            search_btn(ref_name) {
                this.$refs[ref_name].onSearch();
            },
            del_btn(ref_name, id) {
                this.$refs[ref_name].onDelete(id);
            },
            edit_btn(ref_name, id) {
                this.$refs[ref_name].showWriteForm(id);
            },
            addsub_btn(ref_name, send_id) {
                this.$refs[ref_name].onAddsub({
                    id: 0,
                    buy_id: send_id,
                    goods_type: "",
                    goods_num: "",
                    client_id: "",
                    note: "",
                });
            },
            deletesub_btn(ref_name, index) {
                this.$refs[ref_name].onDeletesub(index);
            },
            go_tab(activeName, oldActiveName) {
                // console.log(activeName);
                // if (activeName == "1") {
                // this.$refs["main2"].writeForm.role = 4;
                // this.$refs["main2"].searchForm.role = 4;
                // } else if (activeName == "0") {
                // this.$refs["main0"].writeForm.role = "";
                // this.$refs["main0"].searchForm.role = "";
                // }
            },
            goto_report_by_uid(uid) {
                this.$router.push({name: "/admin/report", params: {uid: uid}});
            },
            look_report(id) {
                request({
                    url: "/hospital/Read/make_docx_v2",
                    data: {
                        id,
                    },
                }).then((ret) => {
                    if (ret.code == 1) {
                        window.open(ret.data);
                    }
                });
            },
            mindexMethod(index) {
                return this.padNumber(index, 5, 0);
            },
            padNumber(num, fill) {
                let len = ("" + num).length;
                if (fill > len) {
                    // 新建一个空数组，长度为所缺位数+1，利用join(0)，得到一个000...的字符串
                    num = Array(fill - len + 1 || 0).join(0) + num;
                }
                return num;
            },
        },
    };
</script>
